<template>
    <div class="topic" :class="state" :style="{ '--progress': `${progress * 100}%` }">
        <span v-text="topic.order_index" class="index">
        </span>
        <span class="title">{{ topic.topic }}
        </span>
        <span class="timer">{{ minutes }}:{{ seconds }}</span>
    </div>
</template>

<script>
import moment from "moment"

export default {
    name: 'TopicComponent',
    props: {
        topic: { required: true },
    },
    data() {
        return {
        }
    },
    methods: {
        doubleDigit(number) {
            let nr = new String(number)
            if (nr.length == 1) {
                return '0' + nr
            }
            return nr
        },
    },
    computed: {
        active() {
            return this.activeTopic.topic == this.topic
        },
        activeTopic() {
            return this.$store.getters['topics/active']
        },
        state() {
            if (this.active) {
                return 'inprogress'
            }
            if (this.past) {
                return 'past'
            }
            return 'upcoming'
        },
        past() {
            return this.activeTopic.pastTopics.includes(this.topic.id)
        },
        progress() {
            if (this.active) {
                return (this.activeTopic.topicTime / this.topic.totalMillis)
            }
            return 0
        },
        topics() {
            return this.$store.state.topics.all
        },
        timeDiff() {
            let duration = 0
            if (this.active) {
                duration = this.topic.totalMillis - this.activeTopic.topicTime
            } else if (!this.past) {
                duration = this.topic.totalMillis
            }
            return moment.duration(duration)
        },
        minutes() {
            return this.doubleDigit(this.timeDiff.minutes())
        },
        seconds() {
            return this.doubleDigit(this.timeDiff.seconds())
        },
    },
    watch: {
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/_variables.scss";

.topic {
    display: flex;
    align-items: center;
    justify-content: left;
    border-radius: var(--unit);
    width: 100%;
    background: rgb(51, 52, 57);
    position: relative;
    overflow: hidden;
    gap: calc(var(--unit) * 3);
    padding: calc(var(--unit) * .75) calc(var(--unit) * 2.25);
    line-height: 1;

    &::after {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: var(--progress);
        content: '';
        z-index: 1;
        background: rgb(39, 38, 44);
    }

    &.past {
        >* {
            opacity: .1;
        }
    }

    &.upcoming {
        >* {
            opacity: .5;
        }
    }

    &.inprogress {
        font-weight: bold;
    }

    >* {
        position: relative;
        z-index: 2;
    }

    font-size: calc(var(--unit) * 2.25);

    .index {
        color: $text-color_light;
    }

    .title {
        color: $text-color_light;
        line-height: 1.2;
        transition: 1s ease-out;
        transition-property: font-weight;
    }

    .timer {
        color: $text-color;
        color: $text-color_light;
        margin: 0 0 0 auto;
        font-family: 'Fira Code', monospace;
    }
}
</style>
